import Sidebar from './components/sidebar.js';
import Navbar from './components/navbar.js';
import Chatbot from './components/chatbot.js';
import Progress from './components/progress.js';
import Preloader from './components/preloader.js';
export class ShellUX {
    constructor(shell) {
        this.sidebars = {};
        this.shell = shell;
        this.chatbot = new Chatbot();
    }
    registerSidebar(sidebarName) {
        this.sidebars[sidebarName] = new Sidebar();
        this.shell.emitEvent('ux:sidebar-register', { sidebarName });
    }
    isSidebarVisible(sidebarName) {
        var _a;
        return ((_a = this.sidebars[sidebarName]) === null || _a === void 0 ? void 0 : _a.getVisibility()) || false;
    }
    toggleSidebarVisibility(sidebarName) {
        const registeredSidebar = this.sidebars[sidebarName];
        if (registeredSidebar === null || registeredSidebar === void 0 ? void 0 : registeredSidebar.isToggleAllowed()) {
            registeredSidebar.toggleVisibility();
            if (this.isSidebarVisible(sidebarName)) {
                this.shell.emitEvent('ux:sidebar-show', { sidebarName });
            }
            else {
                this.shell.emitEvent('ux:sidebar-hide', { sidebarName });
            }
        }
    }
    enableSidebarToggle(sidebarName) {
        const registeredSidebar = this.sidebars[sidebarName];
        registeredSidebar === null || registeredSidebar === void 0 ? void 0 : registeredSidebar.enableToggle();
    }
    disableSidebarToggle(sidebarName) {
        const registeredSidebar = this.sidebars[sidebarName];
        registeredSidebar === null || registeredSidebar === void 0 ? void 0 : registeredSidebar.disableToggle();
    }
    isLargeScreenDisplayForced(sidebarName) {
        const registeredSidebar = this.sidebars[sidebarName];
        return registeredSidebar === null || registeredSidebar === void 0 ? void 0 : registeredSidebar.isLargeScreenDisplayForced();
    }
    setForceSiderBarDisplayOnLargeScreen(sidebarName, isForced) {
        const registeredSidebar = this.sidebars[sidebarName];
        registeredSidebar === null || registeredSidebar === void 0 ? void 0 : registeredSidebar.setForceLargeScreenDisplay(isForced);
    }
    onSidebarVisibilityChange(sidebarName, callback) {
        var _a;
        (_a = this.sidebars[sidebarName]) === null || _a === void 0 ? void 0 : _a.onSidebarVisibilityChange(callback);
    }
    showSidebar(sidebarName) {
        const registeredSidebar = this.sidebars[sidebarName];
        if (registeredSidebar) {
            registeredSidebar.show();
            this.shell.emitEvent('ux:sidebar-show', { sidebarName });
        }
    }
    hideSidebar(sidebarName) {
        const registeredSidebar = this.sidebars[sidebarName];
        if (registeredSidebar) {
            registeredSidebar.hide();
            this.shell.emitEvent('ux:sidebar-hide', { sidebarName });
        }
    }
    resetSidebar(sidebarName) {
        const registeredSidebar = this.sidebars[sidebarName];
        if (registeredSidebar) {
            registeredSidebar.reset();
        }
    }
    registerNavbar() {
        this.navbar = Navbar();
        this.shell.emitEvent('ux:navbar-register', {});
    }
    getNavbar() {
        return this.navbar;
    }
    getChatbot() {
        return this.chatbot;
    }
    registerProgress() {
        this.progress = new Progress();
    }
    startProgress() {
        this.progress.start();
    }
    stopProgress() {
        this.progress.stop();
    }
    onProgressStart(callback) {
        this.progress.onStart(callback);
    }
    onProgressStop(callback) {
        this.progress.onStop(callback);
    }
    registerPreloader() {
        this.preloader = new Preloader();
    }
    showPreloader() {
        this.preloader.show();
    }
    onShowPreloader(callback) {
        this.preloader.onShow(callback);
    }
    removeOnShowPreloader(callback) {
        this.preloader.removeOnSHow(callback);
    }
    hidePrelaoder() {
        this.preloader.hide();
    }
    onHidePreloader(callback) {
        this.preloader.onHide(callback);
    }
    removeOnHidePreloader(callback) {
        this.preloader.removeOnHide(callback);
    }
    openChatbot() {
        this.chatbot.show();
    }
    closeChatbot() {
        this.chatbot.hide();
    }
    onChatbotVisibilityChange(callback) {
        this.chatbot.onVisibilityChange(callback);
    }
}
//# sourceMappingURL=ux.js.map